// import PlatformDropdown from "./DropdownSolution/PlatformDropDown";
import { useState } from "react";
import {
  listMenu,
  expressMenu,
  brandsMenu,
  valueAddedServicesMenu,
  logisticsMenu,

} from "../../helpers/menulinks";
import PlatformSolutionBox from "./DropdownSolution/PlatformSolutionBox";

const PlatformSolutonComponent = (props) => {
  // console.log(props);
  const subRoutesNames = {
    express: "Express",
    logistics: "Logistics",
    brands: "Brands",
  };

  const defaultSelected = props.value
    ? `${subRoutesNames[props.value.data]}`
    : "Express";

  const [selected, setSelected] = useState(defaultSelected);
  const [items, setItems] = useState(defaultSelected);
  const [express, setExpress] = useState(expressMenu);
  const [logistics, setLogistics] = useState(logisticsMenu);
  const [brands, setBrands] = useState(brandsMenu);
  const [valueAddedServices, setValueAddedServices] = useState(valueAddedServicesMenu);
  const [types, setTypes] = useState();


  const handleSelected = (newSelection) => {
    setSelected(newSelection);
  };

  const handleItem = (item) => {
    setItems(item);
    if(props.value) {
      props.value.updatePage(item);
    }
  };

  return (
    <div className="flex justify-center">
    <div className="lg:container w-[100%]  grid justify-items-center content-start  sm:my-[4rem] my-[40px] sm:mt-[6rem] sm:mb-[6rem]">
      <h1 className="react-reveal font-bold sm:text-4xl text-2xl text-[#373737]">
        Products and Services
      </h1>
      <hr className="react-reveal hr" />
      <ul className="flex  gap-4 md:flex-row text-sm text-center lg:gap-8 md:gap-10 mt-4">
        {listMenu.map((item, index) => (
          <li
            key={index}
            className={
              selected === item
                ? "font-semibold text-[#ED1C24] cursor-pointer"
                : "cursor-pointer "
            }
            onClick={() => {
              handleSelected(item);
              handleItem(item);
            }}
          >
            {item}
          </li>
        ))}

        <div className="react-reveal hidden">800</div>
        <div className="hidden">0</div>
      </ul>
      <div className="flex">
        {/* {items === "Express" && <PlatformSolutionBox items={express} />}
        {items === "Logistics" && (
          <PlatformSolutionBox items={logistics} />
        )} */}
        {items === "Express" && <PlatformSolutionBox items={express} />}
        {items === "Logistics" && (
          <PlatformSolutionBox items={logistics} />
        )}
        {items === "Brands" && (
          <PlatformSolutionBox items={brands} />
        )}
        
      </div>
    </div>
    </div>
  );
};

export default PlatformSolutonComponent;